module.exports = __webpack_public_path__ + "static/media/404assest.f8a8c2a0.png";